import { render, staticRenderFns } from "./AssetsFieldset.vue?vue&type=template&id=20476e6e"
import script from "./AssetsFieldset.vue?vue&type=script&lang=js"
export * from "./AssetsFieldset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports